(() => {
  if (window.__eckoCardScroll) return;
  window.__eckoCardScroll = true;

  const SELECTOR =
    '#product-grid .grid__item, .product-grid .grid__item, .collection-list .grid__item';
  const VISIBLE = 'is-inview';
  const ANIMATE = 'card-scroll--animate';
  let observer;

  const showCard = (card) => {
    card.classList.remove(VISIBLE);
    void card.offsetWidth;
    card.classList.add(VISIBLE);
  };

  const hideCard = (card) => {
    card.classList.remove(VISIBLE);
  };

  const observe = (root = document) => {
    const cards = Array.from(root.querySelectorAll(SELECTOR));
    if (!cards.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach((card) => card.classList.add('card-scroll', VISIBLE));
      return;
    }

    if (observer) observer.disconnect();

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          if (entry.intersectionRatio >= 0.18) {
            if (!card.classList.contains(VISIBLE)) showCard(card);
            return;
          }

          if (entry.intersectionRatio <= 0.02) hideCard(card);
        });
      },
      {
        threshold: [0, 0.02, 0.18, 0.35, 0.6],
        rootMargin: '0px 0px -8% 0px',
      }
    );

    cards.forEach((card, index) => {
      card.classList.add('card-scroll', ANIMATE);
      card.style.setProperty('--card-index', String(index % 4));
      observer.observe(card);
    });
  };

  const start = () => observe(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));

  const grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver(() => observe(document)).observe(grid, { childList: true });
  }
})();
